export default {
  'cart.title': 'Cart',
  'cart.breadcrumb.home': 'Home',
  'cart.totalCount': '{{count}} items / {{quantity}} units',
  'cart.emptyCart': 'Empty Cart',
  'cart.emptyTitle': 'Your cart is empty',
  'cart.emptyDesc': 'Add products you like to your cart and request a quote all at once.',
  'cart.browseProducts': 'Browse Products',
  'cart.selectAll': 'Select All ({{selected}}/{{total}})',
  'cart.deleteSelected': 'Delete Selected',
  'cart.unitPrice': 'Unit Price',
  'cart.quoteInquiry': 'Quote Inquiry',
  'cart.amount': 'Amount',
  'cart.totalAmount': 'Total Amount',
  'cart.totalUnits': '(Total {{count}} units)',
  'cart.continueShopping': 'Continue Shopping',
  'cart.checkout': 'Place Order',
  'cart.remove': 'Remove',
  'cart.toastSelectItem': 'Please select products to order',
};